import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, TrophyIcon, XIcon } from 'lucide-react';
const notThis = ['This is not a random collection of techniques copied from YouTube.', 'This is not a theory manual you need to rewrite before it works in a real class.', 'This is not content designed for a different type of instructor that you have to completely adapt.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-carbon-graphite relative overflow-hidden" data-id="element-302" data-mp="z261j30xrrtd">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gold/50" data-id="element-303" data-mp="u3bibzz2418q" />
      <div className="max-w-4xl mx-auto text-center" data-id="element-304" data-mp="18343lfrtdp9b">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-305" data-mp="17zq3yfajbu5k">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full border border-gold text-gold mb-5" data-id="element-306" data-mp="2jfwt0jx4u1m7">
            <TrophyIcon size={24} data-id="element-307" data-mp="2fhpc9p2o50b0" />
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-white" data-id="element-308" data-mp="2bwicj3e4ycad">
            The most complete Brazilian Jiu Jitsu teaching library for
            instructors worldwide
          </h2>
          <h3 className="text-xl font-bold text-gold mb-3" data-id="element-309" data-mp="2kw5blije7609">
            Brazilian Jiu Jitsu Coach Ready — A Complete 6-in-1 Teaching System
          </h3>
          <p className="text-base md:text-lg text-mist mb-10" data-id="element-310" data-mp="2pt45q1323cyg">
            100 ready-to-teach lessons · 5 Strategic Bonuses · Everything ready
            to use from today
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-311" data-mp="225w1znla0byj">
          <div className="space-y-3 bg-carbon p-6 rounded-2xl border border-carbon-line" data-id="element-312" data-mp="224co23n3eczx">
            {notThis.map(item => <div key={item} className="flex items-start gap-3" data-id="element-313" data-mp="26ygqc9lexwuo">
                <XIcon className="text-ash shrink-0 mt-1" size={18} data-id="element-314" data-mp="19gp2omdzzic8" />
                <p className="text-smoke text-sm" data-id="element-315" data-mp="1efjl3n81z4vt">{item}</p>
              </div>)}
          </div>
          <div className="bg-carbon p-6 rounded-2xl border border-gold" data-id="element-316" data-mp="2hq78q5ganbp1">
            <div className="flex items-start gap-3" data-id="element-317" data-mp="2csntp3bruuw1">
              <CheckIcon className="text-gold shrink-0 mt-1" size={20} data-id="element-318" data-mp="2crvyvuq0116t" />
              <p className="text-white font-medium text-base leading-relaxed" data-id="element-319" data-mp="2qi943pbia1sg">
                This is a complete professional 6-in-1 teaching system — so you
                walk into every class fully prepared, confident and ready to
                deliver a session your students will actually feel.
              </p>
            </div>
          </div>
        </div>
        <p className="mt-8 text-gold font-bold uppercase tracking-widest text-xs sm:text-sm" data-id="element-320" data-mp="27sszapssfn68">
          Visual techniques • Drills • Progressions • Coaching frameworks
        </p>
        <p className="mt-2 text-smoke text-sm" data-id="element-321" data-mp="22waxnysr84y4">
          Not a text-heavy manual — a visual coaching system you open and teach from.
        </p>
      </div>
    </section>;
}